export function slugify(str: string): string {
  return str.split(' ').join('-').toLowerCase();
}

export function deslugify(str: string): string {
  return str.split('-').join(' ').toLowerCase();
}
